<template>
  <main>
    <OnePager v-bind="extendedOnePageProps" />
  </main>
</template>

<script>
import OnePager from '@/components/OnePager'
import { MembershipTypes } from '@/enums/member'
import { OnePagerTypes } from '@/enums/signup'
import OnePagerMixin from '@/mixins/onepager'
import { SET_FORM_FIELD } from '@/utils/store/mutationTypes'

export default {
  name: 'WomenSignupOnePagerMinimal',
  layout: 'minimal',
  components: {
    OnePager
  },
  middleware: ({ store }) => {
    store.commit(`signup/${SET_FORM_FIELD}`, { key: 'membershipType', value: MembershipTypes.women })
    store.commit(`signup/${SET_FORM_FIELD}`, { key: 'freeMembershipType', value: MembershipTypes.women })
  },
  mixins: [OnePagerMixin({ fetchLatestDesign: true, type: OnePagerTypes.womenWithDesignChoice })],
  computed: {
    onePagerType () {
      return OnePagerTypes.womenWithDesignChoice
    },
    extendedOnePageProps () {
      return {
        ...this.onePageProps,
        onePagerType: this.onePagerType
      }
    }
  }
}
</script>
